var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_231203",
    "data-name": "Group 231203",
    transform: "translate(-1255 -266.719)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_57549",
    "data-name": "Path 57549",
    transform: "translate(1255 270.772)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.398437976837158 11.94726276397705 L 3.699218034744263 11.94726276397705 C 2.210868120193481 11.94726276397705 0.999998152256012 10.73639297485352 0.999998152256012 9.248043060302734 L 0.999998152256012 3.699222803115845 C 0.999998152256012 2.210872888565063 2.210868120193481 1.000002861022949 3.699218034744263 1.000002861022949 L 7.398437976837158 1.000002861022949 C 8.886788368225098 1.000002861022949 10.09765815734863 2.210872888565063 10.09765815734863 3.699222803115845 L 10.09765815734863 9.248043060302734 C 10.09765815734863 10.73639297485352 8.886788368225098 11.94726276397705 7.398437976837158 11.94726276397705 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3.699218273162842 2.000002861022949 C 2.76226806640625 2.000002861022949 1.999998092651367 2.762272834777832 1.999998092651367 3.699222564697266 L 1.999998092651367 9.248043060302734 C 1.999998092651367 10.18499279022217 2.76226806640625 10.94726276397705 3.699218273162842 10.94726276397705 L 7.398438453674316 10.94726276397705 C 8.33538818359375 10.94726276397705 9.097658157348633 10.18499279022217 9.097658157348633 9.248043060302734 L 9.097658157348633 3.699222564697266 C 9.097658157348633 2.762272834777832 8.33538818359375 2.000002861022949 7.398438453674316 2.000002861022949 L 3.699218273162842 2.000002861022949 M 3.699218273162842 2.86102294921875e-06 L 7.398438453674316 2.86102294921875e-06 C 9.441457748413086 2.86102294921875e-06 11.09765815734863 1.656192779541016 11.09765815734863 3.699222564697266 L 11.09765815734863 9.248043060302734 C 11.09765815734863 11.29107284545898 9.441457748413086 12.94726276397705 7.398438453674316 12.94726276397705 L 3.699218273162842 12.94726276397705 C 1.656198501586914 12.94726276397705 -1.9073486328125e-06 11.29107284545898 -1.9073486328125e-06 9.248043060302734 L -1.9073486328125e-06 3.699222564697266 C -1.9073486328125e-06 1.656192779541016 1.656198501586914 2.86102294921875e-06 3.699218273162842 2.86102294921875e-06 Z",
    stroke: "none",
    fill: "#bcbcbc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_13839",
    "data-name": "Rectangle 13839",
    transform: "translate(1259 266.719)",
    fill: "#fff",
    stroke: "#bcbcbc",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 13,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 9,
    height: 11,
    rx: 3,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyButton);
export default __webpack_public_path__ + "static/media/copy-button.ea0c531d6db6cef23ff0e43910ca1e8d.svg";
export { ForwardRef as ReactComponent };